"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactDetailsModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var portal_core_1 = require("@ferry/portal-core");
var components_1 = require("@athena-portal/components");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../commonFunctions");
var ContactDetailsModal = /** @class */ (function (_super) {
    __extends(ContactDetailsModal, _super);
    function ContactDetailsModal(props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var _this = _super.call(this, props) || this;
        _this.handleInputChange = function (field) { return function (e) {
            var _a;
            var value = e.target.value;
            if (field === "phone") {
                _this.setState({
                    phone: value,
                    phoneNumberValidated: (0, commonFunctions_1.validatePhoneNumber)(value)
                });
            }
            else if (field === "email") {
                _this.setState({
                    email: value,
                    emailValidated: (0, commonFunctions_1.validateEmail)(value)
                });
            }
            else {
                _this.setState((_a = {}, _a[field] = value, _a));
            }
        }; };
        _this.updateInteractionFields = function () {
            var _a = _this.state, email = _a.email, phone = _a.phone, missingEmail = _a.missingEmail, missingPhone = _a.missingPhone;
            var interaction = _this.props.engine.getInteraction();
            if (missingEmail) {
                journey_services_1.ObjectManipulator.setField("policyHolder.email", interaction, email);
            }
            if (missingPhone) {
                journey_services_1.ObjectManipulator.setField("policyHolder.phoneNumber", interaction, phone);
            }
        };
        _this.handleClose = function () {
            var _a = _this.state, email = _a.email, phone = _a.phone, emailValidated = _a.emailValidated, phoneNumberValidated = _a.phoneNumberValidated;
            var isEmailInvalid = !email.trim() || !emailValidated;
            var isPhoneInvalid = !phone.trim() || !phoneNumberValidated;
            if (isEmailInvalid || (email.trim() && isPhoneInvalid)) {
                _this.setState({ isOpen: false });
                return;
            }
            _this.updateInteractionFields();
            _this.executeEvent("change");
            _this.setState({ isOpen: false });
        };
        _this.getBodyText = function () {
            var _a = _this.state, missingEmail = _a.missingEmail, missingPhone = _a.missingPhone;
            if (missingEmail && missingPhone) {
                return "...we need your email address and your mobile number. We'll use the email to set up your online account, and the mobile number will only be used to contact you about your cover.";
            }
            if (missingEmail) {
                return "...we need your email address. We'll use it to set up your online account.";
            }
            return "";
        };
        _this.isContinueEnabled = function () {
            var _a = _this.state, missingEmail = _a.missingEmail, phoneNumberValidated = _a.phoneNumberValidated, emailValidated = _a.emailValidated;
            if (missingEmail) {
                return emailValidated;
            }
            return phoneNumberValidated && emailValidated;
        };
        _this.policyHolder = (_a = props.interaction) === null || _a === void 0 ? void 0 : _a.policyHolder;
        var showModal = !((_b = _this.policyHolder) === null || _b === void 0 ? void 0 : _b.email) || !((_c = _this.policyHolder) === null || _c === void 0 ? void 0 : _c.phoneNumber);
        _this.state = {
            isOpen: showModal,
            missingEmail: !((_d = _this.policyHolder) === null || _d === void 0 ? void 0 : _d.email),
            missingPhone: !((_e = _this.policyHolder) === null || _e === void 0 ? void 0 : _e.phoneNumber),
            email: ((_f = _this.policyHolder) === null || _f === void 0 ? void 0 : _f.email) || '',
            phone: ((_g = _this.policyHolder) === null || _g === void 0 ? void 0 : _g.phoneNumber) || '',
            phoneNumberValidated: !!((_h = _this.policyHolder) === null || _h === void 0 ? void 0 : _h.phoneNumber),
            emailValidated: !!((_j = _this.policyHolder) === null || _j === void 0 ? void 0 : _j.email),
        };
        return _this;
    }
    ContactDetailsModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, isOpen = _a.isOpen, missingEmail = _a.missingEmail, missingPhone = _a.missingPhone, email = _a.email, phone = _a.phone;
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.handleClose });
        return ((0, jsx_runtime_1.jsxs)(components_1.Modal, { className: "edit-name-modal my-2 info-modal", isOpen: isOpen, children: [(0, jsx_runtime_1.jsx)(components_1.ModalHeader, { close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block warning-icon", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/alert-popup.svg"), alt: "Alert icon" }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium fs-20", children: "Before you continue..." })] }) }), (0, jsx_runtime_1.jsxs)(components_1.ModalBody, { children: [(0, jsx_runtime_1.jsx)("p", { children: this.getBodyText() }), missingEmail && ((0, jsx_runtime_1.jsxs)("div", { className: "mb-3", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "email", children: (0, jsx_runtime_1.jsx)("strong", { children: "Email" }) }), (0, jsx_runtime_1.jsx)("input", { type: "email", id: "email", className: "form-control", value: email, onChange: this.handleInputChange("email") }), !this.state.emailValidated && ((0, jsx_runtime_1.jsx)("p", { className: "m-0 mt-1 text-danger", children: "The email address doesn\u2019t look right..." }))] })), missingPhone && ((0, jsx_runtime_1.jsxs)("div", { className: "mb-3", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "phone", children: (0, jsx_runtime_1.jsx)("strong", { children: "Mobile number" }) }), (0, jsx_runtime_1.jsx)("input", { type: "tel", id: "phone", className: "form-control", value: phone, onChange: this.handleInputChange("phone") }), !this.state.phoneNumberValidated && ((0, jsx_runtime_1.jsx)("p", { className: "m-0 mt-1 text-danger", children: "The phone number doesn\u2019t look right..." }))] }))] }), (0, jsx_runtime_1.jsx)(components_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("button", { className: "btn-primary btn-next", disabled: !this.isContinueEnabled(), onClick: function () { return _this.handleClose(); }, children: "Continue" }) })] }));
    };
    return ContactDetailsModal;
}(plugin_journey_1.WidgetBase));
exports.ContactDetailsModal = ContactDetailsModal;
//# sourceMappingURL=ContactDetailsModal.js.map